// Sezioni dell'app con la barra in basso (tela D9): «Oggi», «Agenda» e, per chi prenota e con il ponte acceso,
// «Richieste» (prenotazioni chieste da RVC, con il numero di quelle da rispondere).
// Magazzino e Altro si aggiungono qui quando le loro schermate sono pronte (niente pulsanti vuoti).
import { t } from '../i18n.js';
import { h, app, icona } from './dom.js';
import { oggiRoma, spostaGiorno } from './date.js';
import { schermataAgenda } from './schermate.js';
import { schermataOggi } from './oggi.js';
import { schermataRichieste } from './richieste.js';
import { creaPonte, ascoltaRichieste, PONTE_URL } from '../dati/ponte.js';
import { puoPrenotare } from '../logica/ruoli.js';

const ICONE = {
  oggi: [['rect', { x: 3.5, y: 5, width: 17, height: 15, rx: 2 }], ['path', { d: 'M3.5 10h17M8 3v4M16 3v4' }]],
  agenda: [['rect', { x: 3.5, y: 4, width: 5, height: 16, rx: 1 }], ['rect', { x: 9.5, y: 4, width: 5, height: 11, rx: 1 }],
    ['rect', { x: 15.5, y: 4, width: 5, height: 14, rx: 1 }]],
  richieste: [['path', { d: 'M4 13l2.5-7h11L20 13v6H4z' }], ['path', { d: 'M4 13h4.5l1 2h5l1-2H20' }]],
};

// L'ultima sezione aperta resta ricordata sul telefono (riaprendo l'app si torna lì).
function leggiSezione(sezioni) {
  try {
    const x = localStorage.getItem('spa.sezione');
    return sezioni.includes(x) ? x : sezioni[0];
  } catch { return sezioni[0]; }
}

/** Richieste di RVC in tempo reale (da ieri in poi) per la barra e per la schermata, e il ponte che le scarica. */
function avviaRichieste(ctx, dispositivo) {
  const ascoltatori = new Set();
  const fonte = { lista: [], ascolta(f) { ascoltatori.add(f); f(fonte.lista); return () => ascoltatori.delete(f); } };
  const ponte = creaPonte(ctx, { nome: dispositivo.nome || '' });
  const stop = ascoltaRichieste(ctx, spostaGiorno(oggiRoma(), -1), (lista) => {
    fonte.lista = lista;
    ponte.richieste(lista);
    for (const f of ascoltatori) f(lista);
  }, (e) => ctx.scatola.registra(e, { dove: 'ponte-richieste' }));
  ponte.giro();
  return { fonte, ponte, ferma: () => { stop(); ponte.ferma(); ascoltatori.clear(); } };
}

export function schermataApp(ctx, dispositivo) {
  const conPonte = !!PONTE_URL && puoPrenotare(dispositivo.ruoli);
  const sezioni = ['oggi', 'agenda', ...(conPonte ? ['richieste'] : [])];
  const ric = conPonte ? avviaRichieste(ctx, dispositivo) : null;
  let ferma = () => {};
  let stopConta = () => {};
  function vai(sezione, giorno) {
    ferma();
    stopConta();
    try { localStorage.setItem('spa.sezione', sezione); } catch { /* niente memoria */ }
    if (sezione === 'agenda') ferma = schermataAgenda(ctx, dispositivo, { giorno });
    else if (sezione === 'richieste') ferma = schermataRichieste(ctx, dispositivo, { richieste: ric.fonte, ponte: ric.ponte });
    else ferma = schermataOggi(ctx, dispositivo, { vaiAgenda: (k) => vai('agenda', k), richieste: ric?.fonte, vaiRichieste: () => vai('richieste') });
    const badge = h('span', { classe: 'badge', id: 'barra-conta', hidden: true });
    app().append(h('nav', { classe: 'barra', id: 'barra', 'aria-label': t('barra.titolo') },
      sezioni.map((k) => h('button', {
        type: 'button', dati: { sezione: k }, 'aria-current': k === sezione ? 'page' : null,
        onclick: () => { if (k !== sezione) vai(k); },
      }, h('span', { classe: 'ico' }, icona(ICONE[k]), k === 'richieste' ? badge : null), h('span', {}, t(`barra.${k}`))))));
    // Numero delle richieste da rispondere sull'icona.
    if (ric) {
      stopConta = ric.fonte.ascolta((lista) => {
        const n = lista.filter((r) => r.stato === 'da-rispondere').length;
        badge.textContent = String(n);
        badge.hidden = !n;
      });
    }
    window.scrollTo(0, 0);
  }
  vai(leggiSezione(sezioni));
  return () => { ferma(); stopConta(); ric?.ferma(); };
}
